module.exports = __webpack_public_path__ + "assets/img/phone.3d359296.png";